import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { admin } from '@repletoryreach/sdk-api';

const KEY = ['admin', 'ai-models'];

/** Every AI model, on or off, with its last 30 days of use (14 October 2026). */
export function useAiModels() {
  return useQuery({ queryKey: KEY, queryFn: () => admin.listAiModels() });
}

/**
 * Switch a model on or off, or change how it is reached. The service answers with the row but without its
 * usage figures, so the list is read again rather than patched with a row that says nobody used it.
 */
export function useUpdateAiModel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ code, change }: { code: string; change: admin.UpdateAiModelRequest }) => admin.updateAiModel(code, change),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

/** Call a text model once, so the owner sees it answer before switching it on. */
export function useTestAiModel() {
  return useMutation({ mutationFn: (code: string) => admin.testAiModel(code) });
}
